import React from "react";
import "../DesignerRenderer.css";
import { HANDLE_CONFIGS } from "../utils";

const ResizeHandles = ({ onResizeStart }) => {
  return (
    <>
      {HANDLE_CONFIGS.map((handle) => (
        <div
          key={handle.key}
          onMouseDown={(e) => onResizeStart(e, handle.key)}
          className={`dr-handle ${handle.className}`}
          style={{ cursor: handle.cursor }}
        />
      ))}
    </>
  );
};

export default ResizeHandles;